var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-side"},[_c('div',{staticClass:"main-side-toolbar",on:{"click":_vm.onBackTop}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"option-box",attrs:{"id":"backTop","data-type":"backtop"}},[_c('img',{attrs:{"src":require("@/assets/img/backtop.png"),"alt":"","srcset":""}}),_c('span',{staticClass:"show-txt"},[_vm._v(" 返回 "),_c('br'),_vm._v(" 顶部 ")])])
}]

export { render, staticRenderFns }